import api from "../config/api";

export const fetchAllSubscriberHistory = async () => {
  const res = await api.get("/subscriptionHistory/");
  return res.data.data;
};

export const fetchSubscriberHistoryById =async (userId) => {
  const res =await api.get(`/subscriptionHistory/?id=${userId}`);  
  
  return res.data.data;

};

export const createSubscriberHistory = async (postData) => {
  const res = await api.post(`/subscriptionHistory/`, postData);
  return res.data;
};

export const updateSubscriberHistory = async (id, postData) => {
  const res = await api.put(`/subscriptionHistory/?id=${id}`, postData);
  return res.data;
};

export const deleteSubscriberHistory = async (id) => {
  const res = await api.delete(`/subscriptionHistory/?id=${id}`);
  return res.data;
};
